<template>
  <div ref="resizeElement" class='touch-content'>
    <fullscreen v-model="isFullscreen" :teleport="teleport" :page-only="pageOnly" >
      <TouchHeader v-if="center && setting" :center='center' :setting='setting' />
      <slot></slot>
      <TouchFooter @toggle='toggleFullscreen' />
    </fullscreen>
  </div>
</template>


<script>
import { component } from 'vue-fullscreen'
import api from '@/assets/js/api';

export default {
    name: 'touchLayout',
    components: {
      fullscreen: component,
    },
    data() {
      return {
          isFullscreen: false,
          teleport: false,
          pageOnly: false,
          center: null,
          setting: null,
      };
    },
    computed: {
      centerId() {
          return this.$store.getters['auth/cId'];
      },
    },
    created() {
      this.init();
    },
    mounted() {
      this.observeResize();
    },
    watch: {
    },
    methods: {
      async init() {
          try {
              const { data } = await this.getCenter();
              this.center = data;
              await this.touchMoniterSetting();
          } catch (error) {
              console.error(error);
          }
      },
      toggleFullscreen() {
        this.isFullscreen = !this.isFullscreen;
      },
      observeResize() {
          const resizeObserver = new ResizeObserver(entries => {
              for (let entry of entries) {
                  const currentHeight = entry.contentRect.height;

                  // console.log(document.documentElement.scrollHeight);
                  if (document.documentElement.scrollHeight < 700) {
                      document.documentElement.style.fontSize = '10px';
                  } else if (document.documentElement.scrollHeight < 800) {
                      document.documentElement.style.fontSize = '12px';
                  } else if (document.documentElement.scrollHeight < 900) {
                      document.documentElement.style.fontSize = '14px';
                  } else {
                      document.documentElement.style.fontSize = '16px';
                  }
              }
          });

          resizeObserver.observe(this.$refs.resizeElement);
      },
      getCenter() {
          // 스웨거 검색: 센터 > 센터조회
          return api.get(`/admin/api/center/${this.centerId}`);
      },
      fetchTouchMoniterSetting() {
          return api.get(`/admin/api/centerTouchMonitorSetting/${this.centerId}`);
      },
      // 터치모니터 설정조회
      async touchMoniterSetting() {
          try {
              const { data } = await this.fetchTouchMoniterSetting();
              console.log("touchMoniterSetting: ", data);
              this.setting = data;
              this.$emit('upload-setting', data);
          } catch (error) {
              console.log(error);
              console.log('터치모니터설정을 불러올수없습니다.');
          }
      },
    },
}
</script>